import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RatingModule } from 'primeng/rating';
import { FileUploadModule } from 'primeng/fileupload';
import { MenuModule } from 'primeng/menu';
import { MessagesModule } from 'primeng/messages';
import { AccordionModule } from 'primeng/accordion';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TooltipModule } from 'primeng/tooltip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { CasesTreatmentsListComponent } from './cases-treatments-list/cases-treatments-list.component';
import { CasesTreatmentsDetailComponent } from './cases-treatments-detail/cases-treatments-detail.component';
import { CasesTreatmentsRoutingModule } from './cases-treatments-routing.module';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        CasesTreatmentsListComponent,
        CasesTreatmentsDetailComponent
    ], imports: [CoreModule,
        CommonModule,
        EditorModule,
        CasesTreatmentsRoutingModule,
        BrowserModule,
        FormsModule,
        TableModule,
        TagModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        ReactiveFormsModule,
        OverlayPanelModule,
        TagModule,
        RatingModule,
        FileUploadModule,
        MenuModule,
        MessagesModule,
        AccordionModule,
        BadgeModule,
        EditorModule,
        TooltipModule,
        ColorPickerModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CasesTreatmentsModule { }
